<template>
  <div>
    <Modal
      ref="modal"
      title="Delete candidate"
      body="Are you sure you want to delete this candidate? Deleting a candidate is a permanent action. We cannot restore this candidate after deletion."
      action="Delete"
      action-color="red"
      @close-modal="handleCancel"
      @handle-action="handleDelete"
    />
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import { toast } from 'vue-sonner';

export default {
  components: {
    Modal,
  },
  data() {
    return {};
  },
  methods: {
    handleDelete() {
      const self = this;
      fetch(`/api/contacts/${self.$route.params.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(async data => {
          if (data.status != 'error') {
            self.$emit('handleContactDelete');
            self.$refs.modal.success();
            await self.$router.push('/contacts');
            toast.success('Candidate deleted', {
              action: { label: 'Dismiss' },
              description: 'Your candidate was successfully deleted.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$refs.modal.error();
            toast.error('Candidate deletion error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleContactDeleteCancel');
    },
  },
};
</script>
